import { render, staticRenderFns } from "./ExpiracaoBanner.vue?vue&type=template&id=71ebacb4&scoped=true&"
import script from "./ExpiracaoBanner.vue?vue&type=script&lang=js&"
export * from "./ExpiracaoBanner.vue?vue&type=script&lang=js&"
import style0 from "./ExpiracaoBanner.vue?vue&type=style&index=0&id=71ebacb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ebacb4",
  null
  
)

export default component.exports